import { CheckIcon } from '@heroicons/react/24/outline';
import * as RadixCheckbox from '@radix-ui/react-checkbox';
import PropTypes from 'prop-types';

import twclsx from 'utils/twclsx';

const rootStyles = Object.values({
    base: 'h-25 w-25 peer rounded flex items-center justify-center shrink-0',
    // TODO: shorter syntax to DRY up data attr selector?
    unchecked: 'data-[state=unchecked]:bg-white data-[state=unchecked]:border data-[state=unchecked]:border-grey-light',
    checked: 'data-[state=checked]:bg-kale data-[state=checked]:if:bg-beet',
    disabled: 'data-disabled:cursor-not-allowed',
    disabledChecked: 'data-disabled:data-[state=checked]:bg-grey-light',
    disabledUnchecked: 'data-disabled:data-[state=unchecked]:bg-grey data-disabled:data-[state=unchecked]:border-grey',
});

const labelStyles = {
    base: 'body-desktop-lg font-grotesk pl-20',
    bold: 'body-desktop-lg font-grotesk-bold pl-20',
    disabled: 'peer-disabled:text-grey peer-disabled:cursor-not-allowed pl-20',
    small: 'text-body-mobile-md pl-10',
    smallGrey: 'text-body-mobile-md text-grey pl-10',
    xsmallBold: 'text-body-xs font-grotesk-bold pl-10 text-black',
    smallBold: 'text-body-sm font-grotesk-bold pl-10 text-black',
};

function Checkbox({
    defaultChecked,
    disabled,
    id,
    label,
    labelStyle,
    name,
    positioningClasses,
    styles = {},
    wrapperClassName,
    ...rootProps
}) {
    return (
        <div className={`flex items-center ${wrapperClassName}`}>
            <RadixCheckbox.Root
                id={id}
                name={name}
                className={twclsx(rootStyles, positioningClasses)}
                defaultChecked={defaultChecked}
                disabled={disabled}
                {...rootProps}
            >
                <span className="sr-only">Checkbox</span>
                <RadixCheckbox.Indicator>
                    {/* TODO: apply brand colors when we tackle theming. */}
                    <CheckIcon
                        className={twclsx('w-20 stroke-[3px]', { 'text-grey': disabled }, { 'text-white': !disabled })}
                    />
                </RadixCheckbox.Indicator>
            </RadixCheckbox.Root>
            <label
                htmlFor={id}
                className={twclsx(disabled ? labelStyles.disabled : labelStyles[labelStyle], styles.label)}
            >
                {label}
            </label>
        </div>
    );
}

Checkbox.propTypes = {
    defaultChecked: PropTypes.bool,
    disabled: PropTypes.bool,
    id: PropTypes.string.isRequired,
    label: PropTypes.node,
    labelStyle: PropTypes.oneOf(Object.keys(labelStyles)),
    positioningClasses: PropTypes.string,
    wrapperClassName: PropTypes.string,
};

Checkbox.defaultProps = {
    defaultChecked: false,
    disabled: false,
    label: null,
    labelStyle: 'base',
    positioningClasses: '',
    wrapperClassName: '',
};

export default Checkbox;
